var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlant = function SvgPlant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3725 20.8961C12.9248 20.8961 13.3725 20.4484 13.3725 19.8961V12.4389C17.4868 12.058 20.8773 8.55322 20.9916 4.32465V3.71512C20.9916 3.0675 20.4964 2.57227 19.8487 2.57227H19.2011C14.8583 2.68655 11.2011 6.34369 11.0868 10.7246V10.9532C9.67731 9.5056 7.73445 8.55322 5.60112 8.47703L4.61064 8.43893C4.30588 8.43893 4.00112 8.55322 3.77254 8.78179C3.54397 9.01036 3.42969 9.31512 3.42969 9.61988L3.46778 10.5723C3.54397 14.6866 6.97254 18.1151 11.0868 18.3056V19.8961C11.0868 20.4484 11.5345 20.8961 12.0868 20.8961H12.3725ZM18.6297 4.93417C18.2487 7.56274 16.0011 9.81036 13.4106 10.1532C13.7916 7.52465 16.0011 5.27703 18.6297 4.93417ZM5.75349 10.8008C8.49635 11.0294 10.8202 13.3532 11.0106 16.058C8.26778 15.8675 5.94397 13.5056 5.75349 10.8008Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plant.0e76aa5e.svg";
export { ForwardRef as ReactComponent };